var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasicLayout',{scopedSlots:_vm._u([{key:"wrapper",fn:function(){return [_c('el-card',[_c('clear-cache-apply'),_c('sync-data')],1),_c('basic'),_c('card'),_c('spin'),_c('recommend'),_c('join'),_c('emot')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }